import { render, staticRenderFns } from "./CreateTarget.vue?vue&type=template&id=f13f09c4&"
import script from "./CreateTarget.vue?vue&type=script&lang=ts&"
export * from "./CreateTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports